// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"emphasized-text-view_shadow__cOW-J","emphasized":"emphasized-text-view_emphasized__3CJQ-"};